import type { User } from '~/root';
import algolia from '~/services/algolia.client';
import gtm from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  buttonName: string;
  pagePosition: string;
  productId: number;
  queryID?: string | null;
  user: User;
};

class ClickNotificationEvent extends UserEvent<EventData> {
  sendToGtm() {
    if (!this.data.user.isLoggedIn) {
      gtm.pushToDataLayer({
        button_name: this.data.buttonName,
        event: 'register_intent',
        page_position: this.data.pagePosition
      });
    }
  }

  sendToAlgolia() {
    if (this.data.queryID) {
      algolia.convertedObjectIdAfterSearch({
        eventName: 'Notify Me Clicked',
        id: this.data.productId.toString(),
        queryID: this.data.queryID,
        user: this.data.user
      });
    }
  }
}

export default ClickNotificationEvent;
